const isNotAnImage = (file) => {
	if (file?.type === "image/jpeg") return false;
	return true;
};

const isImage = (file) => {
	if (file?.type === "image/jpeg") return true;
	return false;
};

const imageHasSizeHigherThan250kb = (file) => {
	if (file?.size >= 250 * 1024) return true;
	return false;
};

const imageHasSizeLowerThan250kb = (file) => {
	if (file?.size >= 250 * 1024) return false;
	return true;
};

export { isNotAnImage, imageHasSizeHigherThan250kb, imageHasSizeLowerThan250kb, isImage };
